
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {
  infinite: false
});
